class UserTypes {
  constructor() {
    this.SubAdmin = "SubAdmin";
    this.Admin = "Admin";
    this.Owner = "Owner";
    this.HeadAccounting = "HeadAccounting";
    this.AppointmentEmployee = "AppointmentEmployee";
    this.CallCenterEmployee = "CallCenterEmployee";
    this.AccountingEmployee = "AccountingEmployee";
    this.Patient = "Patient";
    this.Therapist = "Therapist";
    this.AssessmentTherapist = "AssessmentTherapist";
    this.UnAssigned = "UnAssigned";
    this.FloorManager = "FloorManager";
  }
}

export default UserTypes;
